import { SET_QUOTE_MODEL_REVISION_ID } from './constants'
import { ActionType } from './types'

export default function quoteModelRevisionReducer(
    state = {},
    action: ActionType,
) {
    const { type, qmrId } = action

    switch (type) {
        case SET_QUOTE_MODEL_REVISION_ID:
            return { ...state, qmrId }
        default:
            return state
    }
}
